// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next/withAnalyticsEvents';
import type { RendererAppearance } from '@atlaskit/renderer/types';
import type { ContentTypeType } from '@confluence/editor-features/entry-points/types.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { RefAttributes } from 'react';
import type { WrappedComponentProps } from 'react-intl';
import type {
	PreviewPageOwnProps,
	PreviewPageActions,
	ClassificationProps,
	EditorTypes,
} from './editorPreviewTypes.ts';

export const PreviewPageComponent: LoadableType<
	Omit<
		Omit<
			PreviewPageOwnProps & {
				contentId?: string;
				contentType: ContentTypeType | null;
				Renderer: any;
				isPageContentRenderer?: boolean;
			} & PreviewPageActions &
				WrappedComponentProps &
				WithAnalyticsEventsProps &
				ClassificationProps,
			'intl'
		> & {
			forwardedRef?: React.Ref<any>;
		},
		keyof WithAnalyticsEventsProps
	> &
		RefAttributes<any>
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PreviewPageComponent" */ './PreviewPageComponent.tsx'
			)
		).PreviewPageComponent,
});

export const PreviewWithRenderer: LoadableType<{
	editorActions: any;
	contentId?: string;
	showTemplateVariablesInPreview?: boolean;
	spaceKey?: string;
	appearance: RendererAppearance;
	adf: string | null;
	style?: any;
	Renderer: any;
	isPageContentRenderer?: boolean;
	isPreviewMode?: boolean;
	editorType?: EditorTypes;
	shouldReduceLeftPadding?: boolean;
	isFullWidthWithCoverImageCustomSites?: boolean;
	isCompanyHub?: boolean;
}> = LoadableLazy({
	loader: async () =>
		// NOTE: placed into the same chunk as this component is used by Tiny editor and also used internally by PreviewPageComponent
		(
			await import(
				/* webpackChunkName: "loadable-PreviewPageComponent" */ './PreviewWithRendererComponent.tsx'
			)
		).PreviewWithRenderer,
});

export { EditorTypes } from './editorPreviewTypes.ts';
export type {
	PreviewPageOwnProps,
	PreviewPageContainerProps,
	PreviewPageActions,
	PreviewPageFCProps,
	PreviewPageComponentProps,
	ClassificationProps,
} from './editorPreviewTypes.ts';
